import React, { useEffect, useState } from "react";

import { getCollection } from "../../../helper/api";
import StoryCard6 from "../../../molecules/story-card6";

import "./latest-news.m.css";

const LatestNews = () => {
  const [activeTab, setActiveTab] = useState(0);

  const [moreStories, setMoreStories] = useState([]);
  const [recentStories, setRecentStories] = useState([]);

  const fetchDataRecentNews = () => {
    try {
      if (!recentStories.length) {
        getCollection("recent-news", 0, 10).then((stories) => {
          setRecentStories(stories);
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMoreNewsData = () => {
    try {
      if (!moreStories.length) {
        getCollection("most-read", 0, 10).then((stories) => {
          setMoreStories(stories);
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeTab === 0) {
      fetchMoreNewsData();
    } else {
      fetchDataRecentNews();
    }
  }, [activeTab]);

  const handleTabSwitch = (tab) => () => {
    setActiveTab(tab);
  };

  const stories = activeTab === 0 ? moreStories : recentStories;

  return (
    <div styleName="wrapper">
      <div styleName="related-collection">
        <div styleName="title-wrapper">
          <div styleName={`title ${activeTab === 0 ? "active" : ""} `} onClick={handleTabSwitch(0)}>
            ಹೆಚ್ಚು ಓದಿದ ಸುದ್ದಿ
          </div>
          <div styleName={`title ${activeTab === 1 ? "active" : ""} `} onClick={handleTabSwitch(1)}>
            ಇತ್ತೀಚಿನ ಸುದ್ದಿ
          </div>
        </div>
        <div styleName="stories">
          {stories.slice(0, 10).map((item, index) => (
            <StoryCard6 story={item} key={index} headerType={10} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LatestNews;
